import { render, staticRenderFns } from "./BeneficiaryHistory.vue?vue&type=template&id=83a93816&"
import script from "./BeneficiaryHistory.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports